"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const common_utils_1 = require("@zapier/common-utils");
const design_system_1 = require("@zapier/design-system");
const react_1 = require("react");
const floatData = {
    content: '1.0',
    href: '/help/create/basics/understand-different-field-types-in-zaps#step-5',
    title: 'Decimal field. Values will be converted into a decimal or float. Click for more details.',
};
const ICON_SIZE = 11;
const HELP_URL_PREFIX = '/help/create/basics/understand-different-field-types-in-zaps#step-';
const typeData = {
    bool: {
        content: (common_utils_1.isolateComponent(react_1.Fragment, null,
            ' ',
            common_utils_1.isolateComponent(design_system_1.Icon, { name: "formRadioCheck", size: ICON_SIZE }),
            ' ',
            common_utils_1.isolateComponent(design_system_1.Icon, { name: "formRadioUnchecked", size: ICON_SIZE }))),
        href: `${HELP_URL_PREFIX}3`,
        title: "True/false field. Values will be converted into 'true' ('yes', 't', or '1') or 'false' ('no', 'f' or '0'). Click for more details.",
    },
    datetime: {
        content: (common_utils_1.isolateComponent(react_1.Fragment, null,
            common_utils_1.isolateComponent(design_system_1.Icon, { name: "actionCalendar", size: ICON_SIZE }),
            common_utils_1.isolateComponent(design_system_1.Icon, { name: "miscClock", size: ICON_SIZE }))),
        href: `${HELP_URL_PREFIX}1`,
        title: "Datetime field. Values will be converted into a datetime. Also allowed: human-readable dates, like '5pm tomorrow' or 'next friday at noon'; or append ' +1h' or ' -2h' to modify datetimes. Be sure to set your timezone settings! Click for more details.",
    },
    decimal: floatData,
    file: {
        content: common_utils_1.isolateComponent(design_system_1.Icon, { name: "fileFilled", size: ICON_SIZE }),
        href: `${HELP_URL_PREFIX}4`,
        title: 'File field. URLs, files or strings will be automatically converted into a file. Click for more details.',
    },
    float: floatData,
    int: {
        content: '1 2 3',
        href: `${HELP_URL_PREFIX}2`,
        title: 'Number field. Values will be converted into a number. Click for more details.',
    },
};
const FieldTypeHelpIcon = ({ type }) => {
    if (!typeData[type]) {
        return null;
    }
    const { content, href, title } = typeData[type];
    return (common_utils_1.isolateComponent(design_system_1.Link, { color: "grey500", href: href, target: "_blank", title: title }, content));
};
exports.default = FieldTypeHelpIcon;
